import service from "@/api/service";
import { GetResponse } from "@/api/comp-setting/response";
import { GetRequest } from "@/api/comp-setting/request";

/**
 * スタンプカード途中特典チケット設定取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-comp-setting", getRequest);
  return response.data as GetResponse;
}
